import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class PillsScene extends MinigameScene {
    //Images
    private grandpa !: Phaser.GameObjects.Image;

    //values
    private springForceMultiplier = 1;
    private physicsShapes;

    private pillsConfig = [
        {x: 545, y: 249, image: CONST.PILLS.PILL2},
        {x: 638, y: 214, image: CONST.PILLS.PILL1},
        {x: 669, y: 257, image: CONST.PILLS.PILL3},
        {x: 759, y: 310, image: CONST.PILLS.PILL2},
        {x: 707, y: 174, image: CONST.PILLS.PILL2},
        {x: 559, y: 199, image: CONST.PILLS.PILL3},
        {x: 773, y: 221, image: CONST.PILLS.PILL3},
        {x: 573, y: 316, image: CONST.PILLS.PILL1},        
        {x: 745, y: 264, image: CONST.PILLS.PILL1}
    ];

    private boxesConfig = [
        {x: 410, y: 335, image: CONST.PILLS.BOX1, requiredPill: CONST.PILLS.PILL3, maxPillDistance: 55},
        {x: 246, y: 335, image: CONST.PILLS.BOX2, requiredPill: CONST.PILLS.PILL2, maxPillDistance: 55},
        {x: 89, y: 335, image: CONST.PILLS.BOX3, requiredPill: CONST.PILLS.PILL1, maxPillDistance: 55}
    ];

    //logic vars
    private pills: object[] = [];
    private boxes: object[] = [];

    constructor(){
        super ({
            sceneName: CONST.SCENES.PILLS,
            duration: 30000,
            startScreenColor: 0xC1E3FF,
            startText: "STAY\nHEALTHY!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: CONST.PILLS.END,
            nextScene: CONST.SCENES.DIE,
            endButtons: {
                normalNoSkip: {x: 466, y: 410, scale: 1.30},
                normalWithSkip: {x: 322, y: 410, scale: 1.30},
                skip: {x: 610, y: 410, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.pills = [];
        this.boxes = [];
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.PILLS.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(426.5, 447.46, CONST.PILLS.SORTTEXT).setDepth(8).setScale(0.87, 0.87);
        this.grandpa = this.add.image(426.5, 240, CONST.PILLS.GRANDPA).setDepth(1);

        this.initPhysics();
        this.spawnBoxes();
        this.spawnPills();
    }

    private initPhysics(){
        this.physicsShapes = this.cache.json.get(CONST.PHYSICS.PILLS);

        this.matter.world.setBounds(0, 0, this.game.renderer.width, this.game.renderer.height);

        let tableImg = this.add.image(this.game.renderer.width/2, this.game.renderer.height/2, CONST.PILLS.TABLE).setDepth(2);
        this.matter.add.rectangle(this.game.renderer.width/2, 440, this.game.renderer.width, 100, {
            isStatic: true,
        });
    }

    private spawnPills(){
        var canDrag = this.matter.world.nextGroup(false);
        this.matter.add.mouseSpring({ length: 0,
                                     stiffness: 0.003,
                                     angularStiffness: 0,
                                     collisionFilter: { group: canDrag } });

        this.pillsConfig.forEach((config) => {
            var pill = this.matter.add.image(config.x, config.y, 
                                            config.image, 
                                            null, 
                                            { chamfer: {radius: 32 }})
                                        .setScale(0.44, 0.44)
                                        .setDepth(10)
                                        .setInteractive()
                                        .setCollisionGroup(canDrag);
    
            pill.isDragging = false;

            this.pills.push(pill);
        });
    }

    private spawnBoxes(){
        var bigBox = this.matter.add.image(665, 335, CONST.PILLS.BIGBOX, null, {shape: this.physicsShapes.bigbox}).setDepth(9); 
       
        this.boxesConfig.forEach(config => {
            var box = this.matter.add.image(config.x, config.y, config.image, null, {shape: this.physicsShapes.box}).setDepth(9); 
        
            box.maxPillDistance = config.maxPillDistance;
            box.requiredPill = config.requiredPill;

            /*var distanxe = config.maxPillDistance;
            this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                .lineBetween(greenBox.x, greenBox.y, greenBox.x + distanxe, greenBox.y + distanxe);
                this.add.graphics({fillStyle: {color: 0x0000ff, alpha: 0.4}})
                .lineBetween(greenBox.x, greenBox.y, greenBox.x - distanxe, greenBox.y - distanxe);*/
            

            box.isPillInside = (pill) => {
                var rotated = this.rotateAroundPoint({x: pill.x, y: pill.y}, {x: box.x, y: box.y}, box.angle);
                return (Math.abs(rotated.x - box.x) < box.maxPillDistance
                    && Math.abs(rotated.y - box.y) < box.maxPillDistance);
            };

            this.boxes.push(box);
        });
    }

    private rotateAroundPoint(vecToRotate: object, point: object, rotation: number){
        var cos = Math.cos(rotation);
        var sin = Math.sin(rotation);

        vecToRotate.x -= point.x;
        vecToRotate.y -= point.y;

        var xNew = vecToRotate.x * cos - vecToRotate.y * sin;
        var yNew = vecToRotate.x * sin + vecToRotate.y * cos;

        vecToRotate.x = xNew + point.x;
        vecToRotate.y = yNew + point.y;

        return vecToRotate;
    }

    _update(time: number, delta: number){
        if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
        var gx = this.grandpa.x;
        this.grandpa.x = Phaser.Math.Interpolation.SmoothStep(0.1, this.grandpa.x, this.input.activePointer.x);

        this.checkPills();
    }

    private checkPills(){
        var solved = true;
        for (let box of this.boxes){
            for (let pill of this.pills){
                if(box.requiredPill === pill.texture.key && !box.isPillInside(pill)){
                    return;
                }
            }
        }

        //if we get here -> all pills are sorted!
        this.triggerWin();
    }

    _timeout(){
        this.loseGame();
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.addAnimation(CONST.TALK.SMILE, CONST.ANIMATIONS.PILLSEND, 60)
        .setOffset(this.grandpa.x - this.game.renderer.width/2, 0)
        .setDepth(2)
        .setLoop(false)
        .start();

        this.winGame(1000);
    }
}
